module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/Guide-1ea6616851e1c8c6a976ac2be489b271.png";